import styles from '../../prize-box-page.module.css';
import clsx from 'clsx';

export const DEFAULT_POINTS_TO_WIN = 20;
export const DEFAULT_CHESTS_TO_WIN = 1;
export const DEFAULT_POINTS_TO_LOSE = 0;

export const bigText = clsx(styles.textYellow);
